export interface ProductList {
  id: string;
  name: string;
  size: string;
  lease: number;
  photosIds: string[] | [];
}
export interface ProductGet {
  id: string;
  status: ProductStatus;
  categoryId: string;
  name: string;
  photosIds: string[] | [];
  sizeFrom: number;
  sizeTo: number;
  lease: number;
  deposit: number;
}
export interface ProductSave {
  id: string;
  status: ProductStatus;
  categoryId: string;
  name: string;
  sizeFrom: number;
  sizeTo: number;
  lease: number;
  deposit: number;
}
export interface ProductSaveReq {
  id: string | null;
  status: ProductStatus | null;
  categoryId: string | null;
  name: string | null;
  sizeFrom: number | null;
  sizeTo: number | null;
  lease: number | null;
  deposit: number | null;
}
export interface ProductTrash {
  id: string;
  status: ProductStatus;
}
export interface ProductSchedule {
  productId: string;
  productName: string;
  renterFio: string;
  from: Date;
  to: Date;
}

export interface Product {
  id: string | null;
  status: ProductStatus | null;
  categoryId: string | null;
  name: string | null;
  photosIds: string[] | [],
  sizeFrom: number | null;
  sizeTo: number | null;
  lease: number | null;
  deposit: number | null;
  color: string | null;
  address: string | null;
  refPoint: string | null;
  isFavorite: boolean | false;
  rejectReason?: string | null;
  isReject?: boolean | null;
  isApproved?: boolean | null;
}

export enum ProductStatus {
  Unknown = 0,
  Draft = 10,
  Available = 20,
  Archive = 80,
  Deleted = 90,
}
export enum ProductListCategory {
  Active = 1,
  Archive = 2,
}
